<div style="float: right">
  <i
    class="material-icons __close-button"
    (click)="onNoClick()"
    matTooltip="Close Popup"
    >close</i
  >
</div>
<!-- <textarea *ngIf="isInspector" #ta [ngModel]="comment" (ngModelChange)= "commentChanged($event)"></textarea> -->
<textarea *ngIf="isInspector" [(ngModel)]="newComment"></textarea>
<span *ngIf="!isInspector">{{newComment}}</span>
<div style="display: flex; justify-content: space-between">
  <button
    *ngIf="isInspector"
    mat-raised-button
    class="button"
    color="warn"
    (click)="updateComment()"
    [class.loading]="savingComment"
    [disabled]="savingComment"
  >
    <span> {{'Save Comment' | translate | async }} </span>
  </button>
</div>
